import { create } from 'zustand';

const useModal = create((set) => ({
  opened: null,
  group: null,
  subgroup: null,
  cohort: null,
  openModal: (opened, group, subgroup, cohort) => set({ opened, group, subgroup, cohort }),
  closeModal: () => set({ opened: null, group: null, subgroup: null, cohort: null }),
}))

export default useModal;
